import * as React from "react";
import { useEffect, useCallback, useRef } from "react";
import { useFormikContext } from "formik";
import { FormikFormGroup } from "components/common";
import ABSKeySecretFieldGroup from "archive/components/azure/ABSKeySecretFieldGroup";
const DEFAULT_SPOOL_DIRECTORY = "/tmp/graylog-archive-spool";
const ArchiveBackendABSFieldGroup = ({ enableSpool = true }) => {
  const {
    values: { id, settings },
    setFieldValue
  } = useFormikContext();
  const azureSettings = settings;
  const isAccountKeySet = azureSettings.key && "is_set" in azureSettings.key;
  const hasInitializedKey = useRef(false);
  const setAccountKey = useCallback(
    (nextAccessKey) => {
      setFieldValue("settings.key", { set_value: nextAccessKey });
    },
    [setFieldValue]
  );
  useEffect(() => {
    if (hasInitializedKey.current) return;
    if (azureSettings.key && "is_set" in azureSettings.key) {
      hasInitializedKey.current = true;
      const isSet = azureSettings.key.is_set;
      setFieldValue("settings.key", isSet ? { keep_value: true } : void 0);
    }
  }, [azureSettings.key, setFieldValue]);
  useEffect(() => {
    if (id) return;
    if (enableSpool) {
      setFieldValue("settings.spool_directory", DEFAULT_SPOOL_DIRECTORY);
    }
    setFieldValue("settings.output_path", "");
  }, [id, enableSpool, setFieldValue]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.endpoint_uri",
      type: "text",
      label: "Azure Blob Endpoint URL",
      help: "Your Azure Blob Endpoint URL, only required if you want to override the default endpoint.",
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.container",
      type: "text",
      label: "Azure Blob Container Name",
      help: "Your Azure Blob Container name.",
      required: true,
      disabled: !!id,
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(ABSKeySecretFieldGroup, { isKeySet: isAccountKeySet, handleAccountKeyChange: setAccountKey }), enableSpool && /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.spool_directory",
      type: "text",
      label: "Spool directory",
      help: "Spool directory for this backend.",
      labelClassName: "",
      wrapperClassName: "",
      required: true
    }
  ));
};
export default ArchiveBackendABSFieldGroup;
